import {GenericContent} from "./GenericContent";

export class Game extends GenericContent {

    gameItems: GameItem[]

    constructor(
        navUrl: string,
        name: string,
        description: string,
        thumbnail: string,
        trackingId: string,
        isPremium: boolean,
        alwaysInRoadmap: boolean,
        gameItems: GameItem[]
    ) {
        super(name, description, thumbnail, navUrl, trackingId, isPremium, alwaysInRoadmap);
        this.gameItems = gameItems;
    }
}

export class GameItem {
    title: string;
    description: string;
    image: string;
    url: string;

    constructor(title: string, description: string, image: string, url: string) {
        this.title = title;
        this.description = description;
        this.image = image;
        this.url = url;
    }
} 